<template>
  <div>
    <div v-show="!isLoading" class="row report_cell">
      <div class="col-md-12">
        <router-link style="display: inline-flex; align-items: center; font-size: 20pt;" :to="{name: 'ClassReport', query: {'course': course_id}}" v-slot="{navigate}">
          <a class="btn btn-default" style="border: 0; text-decoration: initial; cursor: pointer;" @click="navigate">
            <i class="material-icons" style="font-size: 30pt;">arrow_back</i><div class="rep_title">{{name}}</div>
          </a>
        </router-link>
        <div>
          <span v-if="is_ended === false">進行中</span>
          <span v-if="is_ended === true">已到期</span>
          <button class="btn btn-success btn-fill" @click="bind_modal_save_and_prepare_handler" style="float: right;" data-toggle="modal" data-target="#auto_reminder_modal">發出系統提示訊息</button>
        </div>
      </div>
      <!-- reminder -->
      <div class="modal fade" id="auto_reminder_modal" tabindex="-1" role="dialog" style="overflow: auto;">
        <div class="modal-dialog modal-lg" style="min-width: 70%" role="document">
          <div class="modal-content">
            <div class="modal-header text-center">
              <span style="color: #387E1E; font-size: 2rem;">系統提示訊息</span>
            </div>
            <div class="modal-body">
              <div class="container-fluid">
                <!-- content of broadcast message -->
                <form class="form-horizontal" id="reminder_form">
                  <div class="form-group">
                    <label for="temp" class="col-md-2 control-label">發送至:</label>
                    <div class="col-md-10">
                      <el-radio v-model="target_member" label="all" value="all">全部學生</el-radio>
                      <el-radio v-model="target_member" label="not_attempted" value="not_attempted">未完成任務的學生</el-radio>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="temp" class="col-md-2 control-label">標題:</label>
                    <div class="col-md-10">
                      <input type="text" class="form-control" id="auto_reminder_title" name="title" placeholder="標題" value="test_title">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="temp" class="col-md-2 control-label">內容:</label>
                    <div class="col-md-10">
                      <textarea class="form-control" rows="8" id="auto_reminder_content" name="content">內容</textarea>
                    </div>
                  </div>
                </form>
                <!-- save or close -->
                <div style="display: flex; justify-content: space-around;">
                    <el-button class="exit-no-check-btn" plain data-dismiss="modal">關閉</el-button>
                    <el-button type="primary" class="save-btn" data-dismiss="modal" @click="setMsg">發送</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-12" style="display:inline-flex;">
        <div class="rep_class_type">PRE-CLASS</div>
        <div class="rep_datetime">05/16 12:00 - 05/19 02:30</div>
      </div> -->
      <div class="col-md-12 rep_desc">{{description}}</div>
      <div class="col-md-12">
        <div class="rep_no_views">觀看次數: {{no_of_views}}</div>
      </div>
      <div class="col-md-7" style="float: right;">
        <div class="donut-size" style="font-size:4.4em;" percent="0">
          <div class="pie-wrapper">
            <span class="label" style="display:none">
              <span class="num">0</span>
              <span class="smaller">%</span>
            </span>
            <div class="pie" style="clip: rect(0px, 1em, 1em, 0.5em);">
              <div class="left-side half-circle" style="border-width: 0.2em; transform: rotate(0deg);"></div>
              <div class="right-side half-circle" style="transform: rotate(0deg); border-width: 0.2em;"></div>
            </div>
            <div class="shadow" style="border-width: 0.2em;"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4" style="margin-top:30px;">
        <div class="rep_comp_rate">班級進度: <font style="color:rgb(230, 99, 85);font-size:23pt;">{{completion_rate}}%</font>
        </div>
      </div>
      <button class="btn btn-success btn-fill" data-toggle="modal" data-target="#detail_statistic_modal">詳細統計</button>
      <div class="modal fade" id="detail_statistic_modal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <table style="width: 100%;">
                      <tr>
                        <td>學生</td>
                        <td>完成次數</td>
                      </tr>
                      <br>
                      <tr v-for="student in sortedStudents" :key="student.id">
                        <td>{{student.name}}</td>
                        <td>{{count[student.id]}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="data">
        <ChartLine v-if="data.length > 0 && labels.length > 0" :data="data" :labels="labels" :height="200"/>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>

<style scoped>
  .report_cell > .col-md-12 > .row > div {
    padding-top:20px;
  }
  .rep_title {
    color:rgb(115, 119, 123);
    font-size: 18pt;
  }
  .rep_class_type {
    color:rgb(116, 119, 123);
    font-size: 12pt;
    font-weight: bold;
  }
  .rep_datetime {
    color:rgb(169, 171, 176);
    font-size: 12pt;
    font-weight: lighter;
  }
  .rep_desc {
    color:rgb(169, 171, 176);
    font-size: 12pt;
    font-weight: lighter;
  }
  .rep_no_views {
    color:rgb(115, 119, 123);
  }
  .rep_comp_rate {
    color:rgb(115, 119, 123);
  }
  .top_back_title {
    float:left;
    font-size: 18pt;
    font-weight: bold;
    color:rgb(142, 202, 147);
  }
  .top_plug_add {
    float:right;
  }
  .report_cell {
    width:95%;
    -moz-box-shadow: 0 0 5px #8DD;
    -webkit-box-shadow: 0 0 5px #8DD;
    box-shadow: 0 0 5px #8DD;
    background-color: #fff;
    padding: 25px;
    font-size: 15pt;
    font-weight: bold;
    color: rgb(142, 202, 147);
    margin-left: 12px;
    margin-top: 35px;
  }
  .donut-size {
    font-size: 5.4em!important;
  }
</style>

<script>
import Loading from '@/components/Utility/Loading.vue'
import ChartLine from '@/components/Utility/ChartLine.vue'
import $ from 'jquery'
export default {
  data () {
    return {
      isLoading: true,
      course_id: parseInt(this.$route.query.course),
      week_id: parseInt(this.$route.query.week),
      activity_id: parseInt(this.$route.query.activity),
      course_name: '',
      name: '',
      description: '',
      is_ended: '',
      end_datetime: '',
      no_of_views: '',
      completion_rate: '',
      best: '',
      worst: '',
      median: '',
      mean: '',
      upper_quartile: '',
      lower_quartile: '',
      stdev: '',
      students: [],
      count: [],
      labels: [],
      data: [],
      target_member: 'not_attempted'
    }
  },
  components: {
    Loading,
    ChartLine
  },
  computed: {
    sortedStudents () {
      return this.students.slice(0).sort((a, b) => a.name < b.name ? -1 : 1)
    }
  },
  mounted () {
    this.getReportDetail()
    this.getStudents()
  },
  methods: {
    getReportDetail: async function () {
      await this.$store.dispatch('request', {
        route: 'courses/' + this.course_id + '/weeks/' + this.week_id + '/activities/' + this.activity_id + '/report'
      }).then(r => {
        console.log(r)
        this.name = r.name
        this.description = r.description
        this.group = r.group
        this.type = r.type
        this.no_of_views = r.no_of_views
        this.completion_rate = r.completion_rate.toFixed(0)
        this.best = r.detail.best
        this.worst = r.detail.worst
        this.median = r.detail.median
        this.mean = r.detail.mean
        this.upper_quartile = r.detail.upper_quartile
        this.lower_quartile = r.detail.lower_quartile
        this.stdev = r.detail.stdev
        Object.keys(r.detail.chart_data.date).forEach(key => {
          console.log(r.detail.chart_data.date[key])
          this.labels.push(r.detail.chart_data.date[key].label)
          this.data.push(r.detail.chart_data.date[key].data)
        })
        Object.keys(r.detail.chart_data.users).forEach(key => {
          console.log(r.detail.chart_data.users[key])
          this.count[r.detail.chart_data.users[key].label] = r.detail.chart_data.users[key].data
        })
      })
      this.$store.dispatch('request', {
        route: 'courses/' + this.course_id
      }).then(r => {
        console.log(r)
        this.course_name = r.name
      })
      this.$store.dispatch('request', {
        route: 'courses/' + this.course_id + '/weeks/' + this.week_id
      }).then(r => {
        console.log(r)
        this.is_ended = r.is_ended
        this.end_datetime = r.end_datetime
      })
    },
    getStudents: async function () {
      await this.$store.dispatch('request', {
        route: 'courses/' + this.course_id + '/members'
      }).then(r => {
        console.log(r)
        r.forEach((value) => {
          if (value.role === 'student') {
            console.log(value)
            this.students.push(value)
          }
        })
      })
      this.isLoading = false
    },
    bind_modal_save_and_prepare_handler: async function () {
      $('#auto_reminder_title').val('[系統提示] 一項未完成任務')
      $('#auto_reminder_content').val(
        $(`<p>
        這是系統提示。<br /><br />
        你有一個未完成的任務，請在到期日前完成該任務。詳情如下:<br /><br />
        班級: ` + this.course_name + `<br />
        任務名稱: ` + this.name + `<br />
        任務類別: ` + this.type + `<br />
        班級完成度: ` + this.completion_rate + `%<br />
        到期日: ` + this.end_datetime + `</p>`).text().trim()
      )
    },
    setMsg: async function () {
      let fd = new FormData(document.getElementById('reminder_form'))
      fd.append('target_member', this.target_member)

      if (!fd.get('content') || !fd.get('title')) {
        alert('Empty title or content')
        return false
      }
      this.$store.dispatch('request', {
        method: 'post',
        route: 'courses/' + this.course_id + '/weeks/' + this.week_id + '/activities/' + this.activity_id + '/reminder',
        data: fd
      })
    }
  }
}
</script>
